import {SearchIcon} from 'icons';
import {SizeTokenValue} from 'common';
import {Input} from 'Input';

import type {SearchInputProps} from './types';

export const SearchInput: React.FC<SearchInputProps> = props => {
  const startAdornment = (
    <SearchIcon size={props.size === SizeTokenValue.Small ? SizeTokenValue.Small : SizeTokenValue.Medium} />
  );

  return <Input startAdornment={startAdornment} {...props} />;
};
